import {computeTourFacts} from './helpers.ts';
import type {LineString} from 'ol/geom';
import type {Feature} from 'ol';

interface Options {
  profiler: any; // FIXME: define correct type
  bikeSpeed: () => number;
  hikeSpeed: () => number;
  winterhikeSpeed: () => number;
  snowshoeSpeed: () => number;
  mountainBikeSpeed: () => number;
}

export class FactsProfiler {
  profiler_: any;
  bikeSpeed_: () => number;
  hikeSpeed_: () => number;
  winterhikeSpeed_: () => number;
  snowshoeSpeed_: () => number;
  mountainBikeSpeed_: () => number;
  constructor(options: Options) {
    this.profiler_ = options.profiler;
    this.bikeSpeed_ = options.bikeSpeed;
    this.hikeSpeed_ = options.hikeSpeed;
    this.winterhikeSpeed_ = options.winterhikeSpeed;
    this.snowshoeSpeed_ = options.snowshoeSpeed;
    this.mountainBikeSpeed_ = options.mountainBikeSpeed;
  }
  async computeProfile(segment: Feature<LineString>): Promise<void> {
    return this.profiler_.computeProfile(segment).then(() => {
      const xyzm = segment.get('profile');
      const facts = computeTourFacts(
        xyzm,
        this.bikeSpeed_(),
        this.hikeSpeed_(),
        this.winterhikeSpeed_(),
        this.snowshoeSpeed_(),
        this.mountainBikeSpeed_(),
      );
      segment.set('facts', facts, true);
    });
  }
}
